import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';

import { EventService } from '../../core/services/event.service';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { CollectionBaseManagementService } from 'src/app/core/services/collection-base-management.service';
import { KeycloakService } from 'keycloak-angular';
import { GlobalService } from 'src/app/core/services/global.service';
import { MenuService } from 'src/app/core/services/menu.service';
import { Globals } from 'src/app/globals';

@Component({
  selector: 'app-horizontaltopbar',
  templateUrl: './horizontaltopbar.component.html',
  styleUrls: ['./horizontaltopbar.component.scss']
})

/**
 * Horizontal Topbar and navbar specified
 */
export class HorizontaltopbarComponent implements OnInit, AfterViewInit {

  element: any;
  cookieValue: any;
  flagvalue: any;
  countryName: any;
  valueset: any;
  user = ''
  menuItems: Array<any> = [];

  listLang: Array<any> = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' }
  ];

  // tslint:disable-next-line: max-line-length
  constructor(private readonly globalService: GlobalService, private readonly router: Router, private readonly eventService: EventService,
  private keycloakService: KeycloakService,
    public languageService: LanguageService,
    // tslint:disable-next-line: variable-name
    public _cookiesService: CookieService,
    private readonly colBasManSer: CollectionBaseManagementService,
    private readonly menuService: MenuService,
    private globalsService: Globals) {
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activateMenu();
      }
    });
  }

  ngOnInit(): void {
    this.element = this.globalService.nativeDocument.documentElement;

    this.initialize();

    this.cookieValue = this._cookiesService.get('lang');
    const val: any = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
    this.user = this.keycloakService.getKeycloakInstance().profile.firstName || this.keycloakService.getUsername()
  }

  setLanguage(text: string, lang: string, flag: string): void {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Logout the user
   */
  logout(): void {
    this.keycloakService.logout();
    //this.router.navigate(['/account/login']);
  }

  /**
   * On menu click
   */
  onMenuClick(event: any): boolean {
    const nextEl: any = event.target.nextElementSibling;
    if (nextEl) {
      const parentEl: any = event.target.parentNode;
      if (parentEl) {
        parentEl.classList.remove("show");
      }
      nextEl.classList.toggle("show");
    }
    return false;
  }

  ngAfterViewInit(): void {
    this.activateMenu();
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className: any): void {
    const els: any = this.globalService.nativeDocument.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Togglemenu bar
   */
  toggleMenubar(): void {
    const element: any = this.globalService.nativeDocument.getElementById('topnav-menu-content');
    element.classList.toggle('show');
  }


  private _parent(parent: any): void {
    let parent2: any;
    if (parent) {
      parent.classList.remove('active');
      this._removeAllClass('mm-active');
      this._removeAllClass('mm-show');
      parent2 = parent.parentElement;
      this._parent2(parent2);
    }
  }

  private _parent2(parent2: any): void {
    let parent3: any;
    if (parent2) {
      parent2.classList.remove('active');
      parent3 = parent2.parentElement;
      this._parent3(parent3);
    }
  }

  private _parent3(parent3: any): void {
    let parent4: any;
    if (parent3) {
      parent3.classList.remove('active');
      parent4 = parent3.parentElement;
      this._parent4(parent4);
    }
  }

  private _parent4(parent4: any): void {
    let parent5: any;
    if (parent4) {
      parent4.classList.remove('active');
      parent5 = parent4.parentElement;
      this._parent5(parent5);
    }
  }

  private _parent5(parent5: any): void {
    parent5.classList.remove('active');
    const menuelement: any = this.globalService.nativeDocument.getElementById("topnav-menu-content")
    if(menuelement !== null )
    if(menuelement.classList.contains('show'))
    this.globalService.nativeDocument
        .getElementById("topnav-menu-content")
        .classList.remove("show");
  }


  private _addClassParent(parent:any): void {
    let parent2: any;
    if (parent) {
      parent.classList.add('active');
      parent2 = parent.parentElement;
      this._addClassParent2(parent2);
    }
  }

  private _addClassParent2(parent2:any): void {
    let parent3: any;
    if (parent2) {
      parent2.classList.add('active');
      parent3 = parent2.parentElement;
      this._addClassParent3(parent3);
    }
  }

  private _addClassParent3(parent3:any): void {
    let parent4: any;
    if (parent3) {
      parent3.classList.add('active');
      parent4 = parent3.parentElement;
      this._addClassParent4(parent4);
    }
  }
 
  private _addClassParent4(parent4:any): void {
    let parent5: any;
    if (parent4) {
      parent4.classList.add('active');
      parent5 = parent4.parentElement;
      this._addClassParent5(parent5);
    }
  }

  private _addClassParent5(parent5:any): void {
    if (parent5) {
      parent5.classList.add('active');
    }
  }



  /**
   * Activates the menu
   */
  private activateMenu(): void {

    const resetParent: any = (el: any): void => {
      const parent: any = el.parentElement;
      this._parent(parent);
    };

    // activate menu item based on location
    const links: any = this.globalService.nativeDocument.getElementsByClassName('side-nav-link-ref');
    let matchingMenuItem: any = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // reset menu
      resetParent(links[i]);
    }
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (location.pathname === links[i]['pathname']) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      const parent: any = matchingMenuItem.parentElement;
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      this._addClassParent(parent);
    }
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked(): void {
    this.globalService.nativeDocument.body.classList.toggle('right-bar-enabled');
  }

  /**
   * Fullscreen method
   */
  fullscreen(): void {
    this.globalService.nativeDocument.body.classList.toggle('fullscreen-enable');
    if (
      !this.globalService.nativeDocument.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.globalService.nativeDocument.exitFullscreen) {
        this.globalService.nativeDocument.exitFullscreen();
      } else if (this.globalService.nativeDocument.mozCancelFullScreen) {
        /* Firefox */
        this.globalService.nativeDocument.mozCancelFullScreen();
      } else if (this.globalService.nativeDocument.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.globalService.nativeDocument.webkitExitFullscreen();
      } else if (this.globalService.nativeDocument.msExitFullscreen) {
        /* IE/Edge */
        this.globalService.nativeDocument.msExitFullscreen();
      }
    }
  }

  /**
   * Topbar light
   */
  topbarLight(): void {
    this.globalService.nativeDocument.body.setAttribute('data-topbar', 'light');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-size');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-scrollable');
  }

  /**
   * Set boxed width
   */
  boxedWidth(): void {
    this.globalService.nativeDocument.body.setAttribute('data-layout-size', 'boxed');
    this.globalService.nativeDocument.body.setAttribute('data-topbar', 'dark');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-scrollable');
  }

  /**
   * Colored header
   */
  coloredHeader(): void {
    this.globalService.nativeDocument.body.setAttribute('data-topbar', 'colored');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-size');
    this.globalService.nativeDocument.body.removeAttribute('data-layout-scrollable');
  }

  scrollable(): void {
    this.globalService.nativeDocument.body.removeAttribute('data-layout-size');
    this.globalService.nativeDocument.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string): void {
    this.eventService.broadcast('changeLayout', layout);
  }

  /**
   * Initialize
   */
  initialize(): void {
    this.initMenu();
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem): boolean {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }
  isDownloadMenu(item: MenuItem): boolean {
    return item.isDownloadMenu !== undefined ? item.isDownloadMenu : false;
  }
  onDownloadMenuClick(param: string): void{
    this.downloadTemplate(param)
  }
  isVisible(item: MenuItem): boolean {
    return item.isVisible !== undefined ? (item.isVisible==1) : false;
  }

  downloadTemplate(param: string): void{
    this.colBasManSer.downloadTemplate(param)
      .subscribe((data: Response) => {
        let url: string = this.globalService.nativeWindow.window.URL.createObjectURL(data.body);
        let anchor: any = this.globalService.nativeDocument.createElement("a");
        anchor.download = param === 'DD' ? 'DataCompleta.xlsm' : param === 'VD' ? 'DataParcial.xlsm' : 'TemplateSinModalidad.xlsm';
        anchor.href = url;
        anchor.click();
      }, async ( error: any )=> {
        if (error.error instanceof Blob) {
          const blob: Blob = new Blob([error.error]);
          const data: string = await blob.text();
          const errorData: any = JSON.parse(data);
          //display message and details to the user
          if( errorData.mensaje ){ 
            console.error( errorData.mensaje );
          }else{
            console.error("Ocurrió un error en la descarga de la plantilla");
          }
        }else{
          console.error("Ocurrió un error en la descarga de la plantilla");
        } 
      })
  }
  hasPermissions(item: MenuItem): boolean{
    if( !item.roles ) return true;
    return item.roles.some(role => this.keycloakService.getUserRoles().includes(role))
  }

  trackByItemId(index: number, item: MenuItem): number {
    return item.id;
  }

  async initMenu() {
    try {
      const response: any = await this.menuService.getListMenuByUser();
      const menu: MenuItem[] = response.data;
      this.globalsService.setMenu(response.data);
      // habilitar la siguiente linea para leer configuracion de menus de manera estatica y en html cambiar .name por .label
      //this.menuItems= MENU;
      // habilitar la siguiente linea para leer la configuracion de menus de manera dinamica y en html cambiar .label por .name
      this.menuItems = menu;
      } catch (error) {
      console.error(`Error getting menu; please try again later.`);
    };
   }

}
